import { startCase } from "lodash";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useRecoilValue, useSetRecoilState } from "recoil";

import { HR, Label, MultiSelect, Select, TextArea } from "@ryde/controls";
import { useCrudEditContext, usePageContext } from "@ryde/redux";
import {
  bulkOperationsDrawerAF,
  IDropdownItem,
  IExtendableDto,
  PLURAL_KEY,
  serverErrorsCombinedSF,
  SINGLE_KEY,
} from "@ryde/shared";

import { LayoutRight, LayoutRightCrudContentStatic } from "../right";

export const BulkOperationsDrawerGeneric = (): JSX.Element => {
  const { t } = useTranslation();
  const { entity } = usePageContext();
  const errors = useRecoilValue(serverErrorsCombinedSF(entity));

  const setBulkOperationsDrawerState = useSetRecoilState(
    bulkOperationsDrawerAF(entity),
  );

  const {
    data: { dto },
  } = useCrudEditContext<IExtendableDto>();

  const { setValue } = useForm({
    defaultValues: dto,
  });

  const siteSelectOptions: IDropdownItem[] = [];
  const BooleanOptions = [
    {
      value: null,
      label: t("general.DONT_CHANGE"),
    },
    {
      value: "off",
      label: t("general.DISABLE"),
    },
    {
      value: "on",
      label: t("general.ENABLE"),
    },
  ];

  const onSaveClick = (): void => {
    window.alert(t("general.DO_BULK_ACTION"));
  };

  const handleSiteChange = () => (value: unknown) => {
    setValue(
      "id",
      Number(
        (value as { value: string; label: string; __isNew__: boolean }).value,
      ),
    );
  };

  return (
    <LayoutRight
      headerTitle={t(`general.BULK_ACTIONS`)}
      showFooter={true}
      closeClick={() => setBulkOperationsDrawerState?.(false)}
      saveClick={onSaveClick}
      deleteMessage={t(`general.ARCHIVE_SITE_MESSAGE`)}
    >
      <LayoutRightCrudContentStatic serverErrors={errors}>
        <Label>{startCase(t(`site.${SINGLE_KEY}`))}</Label>
        <Select
          options={siteSelectOptions}
          isClearable={true}
          defaultValue={siteSelectOptions.find(el => el.value === null)}
          onChange={handleSiteChange()}
          width="100%"
        />
        <Label>{startCase(t(`tag.${PLURAL_KEY}`))}</Label>
        <MultiSelect
          options={[
            {
              value: "regular",
              label: startCase(t("shiftTemplate.regular")),
            },
            {
              value: "night_only",
              label: t("general.NIGHT_ONLY"),
            },
            {
              value: "tag",
              label: startCase(t(`tag.${SINGLE_KEY}`)),
            },
          ]}
          width="100%"
        />
        <HR />
        <Label>{t("course.isActiveInProduction")}</Label>
        <Select
          options={BooleanOptions}
          isClearable={true}
          defaultValue={BooleanOptions.find(el => el.value === null)}
          onChange={handleSiteChange()}
          width="100%"
        />
        <Label>{t("selectListLabel.TXTBox")}</Label>
        <TextArea placeholder="Text" rows={4} width="100%"></TextArea>
        <Label>{t("course.isActiveInSpecialRide")}</Label>
        <Select
          options={BooleanOptions}
          isClearable={true}
          defaultValue={BooleanOptions.find(el => el.value === null)}
          onChange={handleSiteChange()}
          width="100%"
        />
      </LayoutRightCrudContentStatic>
    </LayoutRight>
  );
};
